import { replacePathParams } from '@/api/utils';

export const txCenterProvidersApiPaths = {
  list: '/facilityservice/txcenterproviders',
  txCenterProviderById: '/facilityservice/txcenterproviders/:logisticProviderId',
} as const;

export const getTXCenterProvidersApiUrl = {
  list: () => txCenterProvidersApiPaths.list,
  logisticProviderById: (logisticProviderId: string) =>
    replacePathParams(txCenterProvidersApiPaths.txCenterProviderById, { logisticProviderId }),
};
